/**
 *
 * Apaleo connect component. Displays a link to connect to apaleo depending on property vendor and user feature access
 *
 */
import { useSelector, useDispatch } from 'react-redux';
import session from 'containers/App/session';
import React from 'react';
import md5 from 'md5';
import { v4 as uuidv4 } from 'uuid';
import { FEATURES } from 'utils/permissions';
import { VENDOR_TYPES } from 'right-revenue-microservice-sdk/lib/constants';
import vendorOauth from 'containers/App/data/endpoints/vendorOauth';
import { useIntl } from 'react-intl';
import messages from './messages';

export const ApaleoConnect = () => {
    const intl = useIntl();
    const authorisedFeatures = useSelector(session.selectors.selectAccessibleFeatures);
    const selectedPropertyVendorId = useSelector(session.selectors.selectVendorId);
    const userToken = useSelector(session.selectors.selectUserToken);
    const propertyId = useSelector(session.selectors.selectSelectedPropertyId);

    const showApaleoConnect =
        authorisedFeatures.includes(FEATURES.apaleoConnect) && VENDOR_TYPES.APALEO === selectedPropertyVendorId;

    window.localStorage.apaleoconnectcheck = window.localStorage.apaleoconnect;
    window.localStorage.apaleoconnect = uuidv4();

    const state = useSelector(vendorOauth.selectors.selectState);
    const dispatch = useDispatch();

    const connectButtonCicked = () => {
        dispatch(vendorOauth.actions.fetch(propertyId));
    };

    let buttonText = intl.formatMessage(messages.buttonConnect);

    if (state.fetched) {
        buttonText = intl.formatMessage(messages.buttonConnecting);
        const { authEndpoint, clientID, redirectUri, scope } = state.data;
        const requiredScopes = scope.replace(/,/g, '%20');
        const stateOauth = md5(userToken + window.localStorage.apaleoconnect);
        const url = `${authEndpoint}?response_type=code&scope=${requiredScopes}&client_id=${clientID}&redirect_uri=${redirectUri}&state=${stateOauth}`;
        window.location.href = url;
    }

    if (state.fetching) {
        buttonText = intl.formatMessage(messages.buttonConnecting);
    }

    if (state.error) {
        buttonText = intl.formatMessage(messages.buttonConnectError);
    }

    return (
        <div>
            {showApaleoConnect && (
                <button type="button" onClick={connectButtonCicked} id="apaleoConnectBtn">
                    {buttonText}
                </button>
            )}
        </div>
    );
};

export default ApaleoConnect;
